import React from "react";
import { twMerge } from "tailwind-merge";
import { theme } from "./index";
interface IntegrationsProps {
  className?: string;
}

export const Integrations: React.FC<IntegrationsProps> = ({ className }) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={twMerge(
      theme,
      className,
    )}
  >
    <path d="M3.76041 1.97913C3.76041 1.56549 3.42197 1.22705 3.00833 1.22705C2.59468 1.22705 2.25624 1.56549 2.25624 1.97913V4.98747H0.752075V9.49997H5.26458V4.98747H3.76041V1.97913ZM6.76874 12.5083C6.76874 13.486 7.40049 14.3133 8.27291 14.6292V17.7729H9.77708V14.6292C10.6495 14.3208 11.2812 13.4935 11.2812 12.5083V11.0041H6.76874V12.5083ZM0.752075 12.5083C0.752075 13.486 1.38383 14.3133 2.25624 14.6292V17.7729H3.76041V14.6292C4.63283 14.3133 5.26458 13.486 5.26458 12.5083V11.0041H0.752075V12.5083ZM15.7937 4.98747V1.97913C15.7937 1.56549 15.4553 1.22705 15.0417 1.22705C14.628 1.22705 14.2896 1.56549 14.2896 1.97913V4.98747H12.7854V9.49997H17.2979V4.98747H15.7937ZM9.77708 1.97913C9.77708 1.56549 9.43864 1.22705 9.02499 1.22705C8.61135 1.22705 8.27291 1.56549 8.27291 1.97913V4.98747H6.76874V9.49997H11.2812V4.98747H9.77708V1.97913ZM12.7854 12.5083C12.7854 13.486 13.4172 14.3133 14.2896 14.6292V17.7729H15.7937V14.6292C16.6662 14.3208 17.2979 13.4935 17.2979 12.5083V11.0041H12.7854V12.5083Z" />
  </svg>
);
